import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";
import EnrollmentTable from "@/app/components/loyaltyLink/EnrollmentTable";
import UrlHelper from "@/app/helpers/UrlHelper";
import SubmissionHistory from "@/app/components/loyaltyLink/SubmissionHistory";
import Breadcrumbs from "@/app/components/shared/breadcrumbs";
import { PageBanner } from "@/app/components/storybook/Banner/PageBanner";
import { BannerVariantEnum } from "@/enums/tokens/bannerVariantEnum";
import { PositionTokensEnum } from "@/enums/tokens/positionTokenEnum";

const ENROLLMENT_TAB = "enrollment";
const HISTORY_TAB = "history";
const TAB_QUERY_KEY = "tab";

const ProgramsSavr = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentTab =
    UrlHelper.getQueryParam(location.search, TAB_QUERY_KEY) || ENROLLMENT_TAB;

  const handleTabChange = (tabKey: string) => {
    navigate({
      pathname: location.pathname,
      search: `?${TAB_QUERY_KEY}=${tabKey}`,
    });
  };

  return (
    <>
      <PageBanner
        variant={BannerVariantEnum.IMPACT}
        contentAlignment={PositionTokensEnum.LEFT}
      >
        <Typography component="h1">
          <Box component="span" sx={{ fontFamily: "Gotham-Bold" }}>
            LOYALTY
          </Box>{" "}
          <Box component="span" sx={{ fontFamily: "Gotham-Book" }}>
            LINK
          </Box>
        </Typography>
      </PageBanner>
      <Box
        sx={{
          px: { xs: 2, sm: 4 },
          mx: "auto",
          maxWidth: "1300px",
          mb: 5,
          boxSizing: "border-box",
        }}
      >
        <Breadcrumbs
          items={[
            { label: "Home", to: "/" },
            {
              label: "IMPACT Programs + Rewards",
              to: "/impact-programs/impact-programs-overview",
            },
            { label: "Loyalty Link", to: "/impact-programs/loyalty-link" },
            {
              label:
                currentTab === HISTORY_TAB ? "Submission History" : "Enrollment",
            },
          ]}
        />
        <Box
          sx={{
            mb: 3,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            gap: { xs: 1, sm: 2 },
          }}
        >
          <Button
            className={
              currentTab === ENROLLMENT_TAB
                ? "darkBlueButtonSolid"
                : "darkBlueButtonOutline"
            }
            onClick={() => handleTabChange(ENROLLMENT_TAB)}
          >
            ENROLLMENT
          </Button>
          <Button
            className={
              currentTab === HISTORY_TAB ? "darkBlueButtonSolid" : "darkBlueButtonOutline"
            }
            onClick={() => handleTabChange(HISTORY_TAB)}
          >
            SUBMISSION HISTORY
          </Button>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            {currentTab === ENROLLMENT_TAB && <EnrollmentTable />}
            {currentTab === HISTORY_TAB && <SubmissionHistory />}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ProgramsSavr;
